// extracted by mini-css-extract-plugin
module.exports = {"checkout-skeleton":"checkoutOptionSkeleton_checkout-skeleton__4Lqu4","button-container":"checkoutOptionSkeleton_button-container__0Z4Du"};